import { Button } from '@/common/ui/button'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationDeleteSectionFromPage from '@/modules/client-setting/api/hooks/useMutationDeleteSectionFromPage'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'
import { useParams } from 'react-router-dom'
interface DeleteSectionFromPageModalProps {
	dynamicPageSectionId: string
}

export default function DeleteSectionFromPageModal({
	dynamicPageSectionId,
}: DeleteSectionFromPageModalProps) {
	const { id } = useParams()
	const queryClient = useQueryClient()
	const { mutate: deleteSectionFromPage } = useMutationDeleteSectionFromPage({
		onSuccess: () => {
			toast.success('ลบ section สำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [DynamicPageQueryKeys.GetDynamicPageById, id],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteSectionFromPage({ dynamicPageSectionId })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบ section ออกจากหน้านี้</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบ section นี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter className="gap-2">
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction
						onClick={handleDelete}
						className="bg-destructive hover:bg-destructive/90"
					>
						ยืนยัน
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
